<template>
	<div>
		<div class="finance-bottom-area" :style="{ paddingBottom: safeAreaInsetBottom + 15 + 'px' }">
			<nio-button round type="btn_outline" v-open-launch-app @click="handleContact">
				联系牛小二
			</nio-button>
			<nio-button
				round
				v-open-launch-app
				:disabled="ordering || !available"
				@click="handlePrimaryAction"
			>
				立即订购
			</nio-button>
		</div>
	</div>
</template>

<script>
import { checkPayStatus, createLead } from '@/model'
import { allCarStatus } from '@/views1/IndexPage/filterOptions'
import { getSafeInsetBottom } from '@/util/unit-transfer'
import util from '@/util/util'
import link from '@/util/link'
import hybrid from '@/util/nativeHybrid'
import { mapState } from 'vuex'

export default {
	name: 'FinanceBottomArea',
	data() {
		return {
			showContact: false,
			ordering: false,
			createdLead: false,
			safeAreaInsetBottom: getSafeInsetBottom(),
			isInWebview: util.isInWebview()
		}
	},
	computed: {
		...mapState('financeCalcState', ['car', 'currentCity']),
		available() {
			const status = this.car && this.car.status && this.car.status.commodity_status
			return !allCarStatus.some(item => item.value === status)
		}
	},
	methods: {
		async handleContact() {
			if (!(await this.handleGotoIM())) return
			this.handleCreateLead()
		},
		async handleGotoIM() {
			try {
				await util.checkLogin()
				hybrid.openURL(
					`nio://conversation?id=${util.getBaseEnvInfo().secondHandChatPersonId}&type=private`
				)
				return true
			} catch (error) {
				return false
			}
		},
		async handleCreateLead() {
			if (this.createdLead) return
			this.createdLead = true
			// 创建二手车线索|留资
			const basic = (this.car && this.car.basic) || {}
			try {
				await createLead.post({
					source_code: 'fUtWoc3q',
					intent_model_code: basic.model || '',
					city_code: (this.currentCity && this.currentCity.code) || ''
				})
			} catch (error) {
				this.createdLead = false
			}
		},
		async handlePrimaryAction() {
			if (!util.isInWebview() || this.ordering) return
			if (!this.available) return
			this.ordering = true
			try {
				await util.checkLogin()
				const { data } = await checkPayStatus.get({}, '/' + this.car.basic.commodity_code)
				if (!data || data.result_code !== 'success') return
				if (data.data.is_payed === true) {
					this.$toast('该车辆已被抢定了，可以看看其他车辆哦')
					return
				}
				link.goToRoute('/orderCreator', { sku_code: this.car.basic.commodity_code })
			} catch (error) {
				return
			} finally {
				this.ordering = false
			}
		}
	}
}
</script>

<style scoped lang="scss">
@import '~@nio-fe/nio-app-ui/es/style';

.finance-bottom-area {
	position: fixed;
	bottom: 0;
	left: 0;
	right: 0;
	z-index: 100;
	display: flex;
	padding: 15px 25px;
	background: var(--bg_primary);

	.nio-button {
		flex: 1;
		min-width: 0;

		& + .nio-button {
			margin-left: 15px;
		}
		height: 45px;
		box-sizing: border-box;
		@include body_1(1.5, 400, false);
	}
}
</style>
